import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { BackendContainer } from '@/components/backend/BackendContainer';
import { AdminLevelsTable } from '@/components/backend/table/AdminLevelsTable';
import { makeMetaTitle } from '@/modules/META';
import { backendApiAdminLevelsFindAllOptions } from '@/modules/api/@tanstack/react-query.gen';

export const Route = createFileRoute('/verwaltung/')({
  head: () => ({
    meta: [makeMetaTitle(['Verwaltungsebenen'])],
  }),
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const { data, isFetching } = useQuery(backendApiAdminLevelsFindAllOptions());

  return (
    <BackendContainer>
      <AdminLevelsTable download fullHeight data={data} isFetching={isFetching} />
    </BackendContainer>
  );
}
